import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayInterpersonalSkillsRatingSelectedPayload {
  shiftId: string;
  rating: number;
}

/**
 * Fires when an office adjusts the interpersonal skills star rating on the
 * end-of-day review page.
 * Event: dental_portal:end_of_day:interpersonal_skills_rating_selected
 */
export function fireEndOfDayInterpersonalSkillsRatingSelected(
  payload: IEndOfDayInterpersonalSkillsRatingSelectedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:end_of_day:interpersonal_skills_rating_selected',
    {
      shift_id: payload.shiftId,
      rating: payload.rating,
    },
  );
}
